import React from 'react';
import './style.scss';
import StepperLeft from './shared/left';
import Stepper from './shared/stepper';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const StepperComponent = (props) => {
  // In case the BE didn't provide appropriate data we'll render a dummy placeholder
  if (!props?.fields || !props?.params) {
    return <GenericPlaceholder componentName="StepperComponent" />;
  }
  // We have multiple variation for this component (light or dark)
  const darkMode = props.params?.theme !== 'lightMode';
  // Destructuring fields
  const { heading, hyperLink, image, text, items, primaryButton, secondaryButton } = props?.fields;

  return (
    <div
      className={clsx(
        'stepper-component-wrapper',
        darkMode && 'stepper-component-wrapper-dark', // This class will override the lightmode
        'add-margins',
        props?.params?.Styles // To apply dynamic margins from the BE
      )}
    >
      {/* This component might be used inside another placeholder
      which already have padding, so we need to remove it's padding in that case */}
      <div
        className={clsx(
          'stepper-component content',
          props?.params?.noPadding === '1' && 'remove-padding'
        )}
      >
        <StepperLeft
          heading={heading}
          text={text}
          image={image}
          darkMode={darkMode}
          link={hyperLink}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
        />
        <Stepper items={items} darkMode={darkMode} />
      </div>
    </div>
  );
};

export default StepperComponent;
